<div
    class="text-grey-400 flex items-center justify-center gap-4 px-24 py-4 lg:justify-end"
    [ngClass]="{
        'text-white': theme() === 'dark' || theme() === 'medium',
    }"
>
    <i class="icon-info text-20"></i>
    <span class="text-16">
        @let l = label() | footnotes;
        <span [innerHTML]="l()"></span>
        &nbsp;
        <a class="underline" [hyundaiRouterLink]="dealer().pages.imprint">Impressum & Rechtliches</a>
    </span>
</div>
